module.exports = __webpack_public_path__ + "collectFalse.3cf584b2.png";